/**
 * Returns the closure data
 *
 * @param {Number} itemID The item ID
 * @return {Object} The item
 */
const getItemClosure = ( itemID ) => {
	return UncannyAutomator._recipe.actions.items.find( item => parseInt( item.id ) === itemID );
}

export default getItemClosure;
